class ReviewsCarouselCards extends HTMLElement {
  constructor() {
    super();

    this.activeCardIndex = 1;

    this.addListener();
  }

  addListener() {
    subscribe(PUB_SUB_EVENTS.slideChange, data => this.onSlideChange(data));
  }

  onSlideChange({ index, carousel }) {
    if (carousel !== this.carousel) return;

    this.activeCardIndex = index;

    this.cards.forEach(card => card.classList.remove("reviews-carousel__card--active"));

    this.cards.forEach(card => {
      const index = Number(card.dataset.index);

      this.updateCardPosition(card);

      if (index === this.activeCardIndex) {
        card.classList.add("reviews-carousel__card--active");
      }
    });
  }

  updateCardPosition(content) {
    content.style.left = "-" + 100 * this.activeCardIndex + "%";
  }

  get carousel() {
    return this.section.querySelector("[data-reviews-carousel]");
  }

  get section() {
    return this.closest("[data-reviews-carousel-section]");
  }

  get cards() {
    return this.querySelectorAll("[data-reviews-card]");
  }
}

customElements.define('reviews-carousel-cards', ReviewsCarouselCards);